import { useState, useEffect } from "react";
import "../component/Exam.css"; // Import CSS

export default function Exam() {
  const [activeTab, setActiveTab] = useState("UpcomingExams");
  const [exams, setExams] = useState({
    UpcomingExams: [],
    ActiveExams: [],
    ExpiredExams: [],
    AttemptedExams: [],
  });
  console.log(exams);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    if (!user.id) return;

    fetch(`https://seeree.in/api/viewExams/${user.id}`)
      .then((res) => res.json())
      .then((data) => setExams(data))
      .catch((error) => console.error("Error fetching exams:", error));
  }, []);

  return (
    <div className="exam-layout">
      {/* Sidebar */}
      <div className="sidebar">
        {["UpcomingExams", "ActiveExams", "ExpiredExams", "AttemptedExams"].map(
          (tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={activeTab === tab ? "active" : ""}
            >
              {tab.replace("Exams", " Exams")}
            </button>
          )
        )}
      </div>

      {/* Main Content */}
      <div className="main-content">
        <h2>{activeTab.replace("Exams", " Exams")}</h2>

        <div className="exam-grid">
          {exams[activeTab]?.length > 0 ? (
            exams[activeTab]?.map((exam, index) => (
              <div key={index} className="exam-card">
                <h3>{exam.exam_name}</h3>
                <p><strong>Subject:</strong> {exam.subject || exam.subject_id}</p>
                <p><strong>Chapter:</strong> {exam.chapter || exam.chapter_id}</p>
                <p><strong>Start:</strong> {exam.start_date}</p>
                <p><strong>End:</strong> {exam.end_date}</p>
                {activeTab === "AttemptedExams" && (
                  <p className="attempted">Attempted on: {exam.attempted_date}</p>
                )}
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", color: "#555", fontSize: "16px" }}>
              No exams found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
